<template>
  <ion-page class="before-test">
    <img class="before-test_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between" style="height: 4rem">
        <div class="nav-icon"></div>
        <span>训前检测</span>
        <div style="display: inline-flex; align-items: center">
          <switch-font-size />
          <img class="nav-icon" :src="getBrandImageUrl('close_icon.png')" alt="" @click="onClose" />
        </div>
      </div>
    </ion-header>
    <div class="before-test_outside">
      <div class="statistic">{{ totalNum }}个单词</div>
      <div class="before-test_page" @scroll="scrollEvent">
        <div class="word-list">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="word-list_item flex-row justify-between align-center cursor-pointer"
            :class="{ 'choose-true': item.mastery === 1, 'choose-false': item.mastery === 8 }"
            @click="onShowParaphrase(index, item, $event)"
          >
            <span class="flex-row align-center flex-wrap">
              <span class="word-style">
                <span class="gray-color font-small-size" style="flex-shrink: 0; font-size: 1rem"
                  >{{ index + 1 }}.&nbsp;</span
                >
                <span class="weight-600 switch-font-size"> {{ item.word }}</span>
              </span>
              <span v-show="item.showParaphrase == 2" class="cnword word-style gray-color ml-3">{{
                item.paraphrase
              }}</span>
            </span>
            <div class="choose-icon flex-row align-center">
              <img
                v-if="item.mastery === 0 || item.mastery === 1"
                class="test-icon"
                src="@/assets/teacher_index/version5/word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.mastery === 8"
                class="test-icon"
                src="@/assets/teacher_index/version5/checked_word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.mastery === 0 || item.mastery === 8"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/word_ok.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <img
                v-if="item.mastery === 1"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/checked_word_true.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <!--                <img-->
              <!--                    class="test-icon ml-3"-->
              <!--                    :src="getBrandImageUrl('speed/not_play_icon.png')"-->
              <!--                    alt=""-->
              <!--                />-->
              <!--                <img-->
              <!--                    v-if="false"-->
              <!--                    class="test-icon ml-3"-->
              <!--                    :src="getBrandImageUrl('speed/playing_icon.png')"-->
              <!--                    alt=""-->
              <!--                />-->
            </div>
          </div>
          <ion-content>
            <ion-infinite-scroll
              id="infinite-scroll"
              threshold="100px"
              :disabled="isDisabled"
              @ionInfinite="loadData($event)"
            >
              <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
              </ion-infinite-scroll-content>
            </ion-infinite-scroll>
          </ion-content>
        </div>
      </div>
    </div>
    <div class="before-test_bottom">
      <div class="before-test_bottom-content flex-row justify-between align-center">
        <span
          >已选择<span class="select-num">{{ selectNum }}</span
          >个单词</span
        >
        <div style="flex-shrink: 0">
          <ion-button class="btn golden_bg" shape="round" @click="onAutoChoice5Word"
            >选择5个
          </ion-button>
          <ion-button class="btn golden_bg" shape="round" @click="onAutoChoice"
            >选择45个
          </ion-button>
          <ion-button class="btn green_bg ml-2" shape="round" @click="onSubmit"
            >开始识记
          </ion-button>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  IonButton,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonPage,
  modalController,
} from "@ionic/vue"

import { checkmarkCircle, closeCircle, library } from "ionicons/icons"

import Sign from "@/views/speed/Sign"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { getBrandImageUrl } from "@/js/brandImages"
import { useDebounceFn } from "@vueuse/core"
import checkOkWord from "@/assets/teacher_index/version5/checked_word_false.svg"
import checkFalseWord from "@/assets/teacher_index/version5/checked_word_true.svg"
import SwitchFontSize from "@/views/other/SwitchFontSize.vue"

export default {
  name: "SpeedBeforeTest",
  components: {
    IonHeader,
    PageWhiteBackground,
    IonPage,
    IonContent,
    IonButton,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    SwitchFontSize,
  },
  props: ["studentId", "classType"],
  setup() {
    return {
      closeCircle,
      checkmarkCircle,
      library,
    }
  },

  data() {
    return {
      isDisabled: false,
      dataList: [],
      currentPage: 1,
      pageSize: 50,
      selectNum: 0,
      alreadyNnow: 0, //已经掌握
      courseId: undefined,
      courseName: undefined,
      selectAll: false, //全部选择
      submitting: false, //控制重复提交

      notHaveNewWords: undefined,
      scrollQueryFn: null,
      totalNum: 0,
    }
  },

  mounted() {
    this.userinfo = this.store.getUser()
    this.getCurrentLibrary()
    // this.alert('认识的词点 <b>✓</b>,<br>不熟悉的点 <b>×</b>。');
    this.alert(
      `<div style="line-height: 30px;">认识的词选 <img class="vertical-middle" style="width: 20px;" src="${checkOkWord}" />，\n不熟悉的选 <img class="vertical-middle" style="width: 20px;"src="${checkFalseWord}" />。</div>`,
      "",
      "",
      true
    )
    this.scrollQueryFn = useDebounceFn(() => {
      this.getCurrentLibrary()
    }, 500)
  },

  methods: {
    getBrandImageUrl,

    scrollEvent(e) {
      // 数据已加载完时不再触发加载
      if (this.isDisabled) {
        return
      }
      const el = e.target
      // 滚到底部时加载下一页（用原生判断，避免每次滚动都调用 useScroll 注册监听器）
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
        this.scrollQueryFn()
      }
    },
    routerBack() {
      modalController.dismiss()
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.dataList = []
      this.currentPage = 1
      this.getCurrentLibrary(RefreshAnimationEvent)
    },

    onShowParaphrase(index, item) {
      //this.playSound(item.word);
      this.playSoundTemp(item)
      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          if (this.dataList[i].showParaphrase < 2) {
            this.dataList[i].showParaphrase++
          } else {
            this.dataList[i].showParaphrase = 0
          }
        }
      }
    },

    countSelectNum() {
      this.selectNum = 0
      this.alreadyNnow = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          this.selectNum++
        } else if (this.dataList[i].mastery == 8) {
          this.alreadyNnow++
        }
      }
    },

    //学新
    async openSign() {
      const modal = await modalController.create({
        component: Sign,
        componentProps: { studentId: this.studentId, step: 1 },
        cssClass: "modal_controller_class",
        backdropDismiss: false, // 禁止点击背景关闭
        keyboardClose: false, // 禁止ESC按键关闭
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      console.log(data)
      if (data) {
        await modalController.dismiss({ ...data })
      }
    },

    //提交单词列表
    onSubmit() {
      //控制重复提交
      if (this.submitting) {
        return
      }

      this.countSelectNum()
      if (this.selectNum + this.alreadyNnow == 0) {
        openMsgToast("请选择单词")
        // this.alert();
        return
      }

      //创建表单参数对象
      const param = { studentId: this.studentId }

      //数据提交地址，根据是否陪练体验而不同
      let url = "/vocabulary/beginNewClass"

      //如果用户就是自己，则判断为陪练自己在体验教学流程
      if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
        url = "/vocabulary/beginTrailClass"
        param.courseId = this.store.getTrialCourseId()
      }

      //陪练给用户上课
      else {
        const appointment = this.store.getAppointment()
        param.aptmId = appointment.aptmId
        param.courseId = appointment.courseId
        param.courseName = appointment.courseName
      }

      //创建已经选择的单词列表
      const selectedItem1 = []
      const selectedItem2 = []

      if (this.dataList && this.dataList.length > 0) {
        // 打勾的单词mastery=8，打叉的mastery=1
        //此处找出所有被打了X标记的单词
        this.dataList.forEach((item) => {
          if (item.mastery > 0) {
            let obj = {
              vocabularyId: item.vocabularyId,
              studentId: this.studentId,
              word: item.word,
              courseId: item.courseId,
              mastery: item.mastery,
              paraphrase: item.paraphrase,
              pronunciation: item.pronunciation,
            }
            selectedItem1.push(obj)
            if (item.mastery == 1) {
              selectedItem2.push(obj)
            }
          }
        })
      }

      //提交所有打了标记的单词
      param.list = selectedItem1

      //如果是陪练教学流程，则只需要把打叉的单词提交
      if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
        param.list = selectedItem2
      }
      console.log()
      //锁定提交状态，避免重复提交
      this.submitting = true

      this.ajax.post(url, param).then((res) => {
        //释放提交状态
        this.submitting = false
        if (res.data.success) {
          //本地只存储打了叉的单词
          param.list = selectedItem2
          console.log(param.list, "x")
          if (res.data.trialId) {
            this.store.setTrialId(res.data.trialId)
          }
          //如果选择了单词，则打开单词识记界面
          if (this.selectNum > 0) {
            if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
              this.openSign()
            } else {
              this.createForget().then(() => {
                this.openSign()
              })
            }
          } else {
            modalController.dismiss({ status: "BEFORE_TEST" })
          }
        }
      })
    },
    async createForget() {
      const appointment = this.store.getAppointment()
      const params = {
        aptmId: appointment.aptmId,
        startTime: appointment.beginTime,
      }
      return this.ajax.post("/forget/generateForget", params)
    },
    onTempSelectAllYes() {
      this.selectAll = true
      this.dataList.forEach(function (item) {
        item.mastery = 8
        item.yesColor = "success"
        item.notColor = "gainsboro"
        item.showParaphrase = 0
      })
      this.countSelectNum()
    },

    //自动选择 5个
    onAutoChoice5Word() {
      this.selectAll = true
      let selectedItem1 = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          selectedItem1.push(this.dataList[i])
        }
      }

      if (selectedItem1.length >= 45) {
        selectedItem1 = []
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].mastery = 0
        }
      }

      let num = 0

      for (let i = 0; i < this.dataList.length; i++) {
        if (num >= 5 || selectedItem1.length >= 45) {
          break
        }

        if (this.dataList[i].mastery == 0) {
          this.dataList[i].mastery = 1
          selectedItem1.push(this.dataList[i])
          num++
        }
      }
      this.countSelectNum()
    },

    //自动选择
    onAutoChoice() {
      this.selectAll = true
      const selectedItem1 = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          selectedItem1.push(this.dataList[i])
        }
      }

      for (let i = 0; i < this.dataList.length; i++) {
        if (selectedItem1.length < 45) {
          if (this.dataList[i].mastery == 0) {
            this.dataList[i].mastery = 1
            this.dataList[i].yesColor = "gainsboro"
            this.dataList[i].notColor = "danger"
            selectedItem1.push(this.dataList[i])
          }
        } else {
          break
        }
      }
      this.countSelectNum()
    },

    // item.mastery = 0 未选择 1 错误 8 正确
    //全部取消选择
    onCancelChoice() {
      this.selectAll = false
      this.dataList.forEach(function (item) {
        item.mastery = 0
        item.showParaphrase = 0
      })
      this.countSelectNum()
    },

    onClickYes(item) {
      if (item.mastery == 8) {
        item.mastery = 0
      } else {
        item.mastery = 8
      }

      item.showParaphrase = item.mastery === 8 ? 2 : 0
      this.countSelectNum()
    },

    onClickNot(item) {
      if (item.mastery == 1) {
        item.mastery = 0
      } else {
        if (this.selectNum >= 45) {
          this.alert("不能再选啦~~")
          return
        }

        item.mastery = 1
      }

      item.showParaphrase = item.mastery === 1 ? 2 : 0

      this.countSelectNum()
    },

    queryVocabulary(ev) {
      this.notHaveNewWords = undefined

      const params = {
        courseId: this.courseId,
        studentId: this.studentId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.ajax.post("/vocabulary/queryNotInPersonal", params).then((res) => {
        const page = res.data.page
        this.totalNum = res.data.page.total
        if (page.list && page.list.length > 0) {
          for (let i = 0; i < page.list.length; i++) {
            page.list[i].mastery = 0
            page.list[i].showParaphrase = 0
            this.dataList.push(page.list[i])
          }
        }

        //本课程无新单词可学
        else {
          this.notHaveNewWords = "本训练已完成，请切换其它训练继续训练！"
          // 数据已全部加载完，关闭无限滚动，避免反复触发请求导致页面卡死
          this.isDisabled = true
        }

        if (ev) {
          ev.target.complete()
        }
        this.currentPage++
      })
    },

    loadData(ev) {
      this.queryVocabulary(ev)
    },

    getCurrentLibrary(ev) {
      this.ajax.get("/course/getCurrentCourse?studentId=" + this.studentId).then((res) => {
        if (res.data.success) {
          this.courseName = res.data.data.courseName
          this.courseId = res.data.data.courseId
          this.queryVocabulary(ev)
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.before-test {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 5vh;
  user-select: none;
  -webkit-user-select: none;
  background: #f2f3f6;
  z-index: 1;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: 100%;
    background: #ffffff;
    border-radius: 0.5rem;

    .statistic {
      color: var(--font-grey-color);
      height: 2rem;
      line-height: 2rem;
      padding-left: 1rem;
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888; /* 滚动条的颜色 */
    border-radius: 10px; /* 滚动条的角度样式 */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* 鼠标悬停时的颜色 */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动条轨道的颜色，可以理解为背景 */
    border-radius: 10px; /* 滚动条轨道的圆角 */
  }

  &_page {
    width: 100%;
    height: calc(100vh - 9rem);
    overflow-y: scroll;
    overflow-x: hidden;

    .word-list {
      &_item {
        padding: 4vw 3vw;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          display: flex;
          font-size: var(--font-size);
          word-break: break-all;
          align-items: center;
        }

        .choose-icon {
          width: 18%;
          flex-shrink: 0;
        }
      }

      .item-checked {
        border: 1px solid var(--theme-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .test-icon {
        width: 1.8rem;
      }
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;
    box-sizing: border-box;

    &-content {
      flex-shrink: 0;
      height: 100%;
      padding: 0 3vw;
      color: #9a9b9c;

      .select-num {
        color: #ffad00;
        font-size: 1.2rem;
        font-weight: 600;
      }
    }
  }
}

::v-deep(.btn) {
  height: 2rem;
  width: 5rem;
}
</style>
